export default [
  {
    icon: 'mdi-close',
    title: 'Batalkan Tanggapan',
    event: 'onBatal',
    akses: 'psp-peserta-pendampingan-pa.batal',
  },
  {
    icon: 'mdi-account-key',
    title: 'Batal Kunci',
    event: 'onBatalKunci',
    akses: 'psp-peserta-pendampingan-pa.batal-kunci',
  },
];
